const _version = "2.8.5"
function version() {
    return _version;
}
export default version
